import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/hooks/index';
import { useActiveApplicationIdentifierNullSafe } from '@trinity/chat-components/containers/UserApplications/useActiveApplicationIdentifier';
import { useActiveBrandIdentifierNullSafe } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';

type Params = {
  kol: {
    id: number | string;
    name: string;
  };
};

export const useDownloadKolProfile = (params: Params) => {
  const brandIdentifier = useActiveBrandIdentifierNullSafe();
  const applicationIdentifier = useActiveApplicationIdentifierNullSafe();

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [`kol-profile:download`, params.kol.id, brandIdentifier, applicationIdentifier],
    queryFn: ({ queryKey: [, kolId] }) => {
      throw new Error(`Not implemented`);
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      // onResponse: (res) => ({
      //   filename: `HCP 360 Profile: ${params.kol.name}.docx`,
      //   type: 'blob',
      //   value: res.data,
      // }),
    },
  });
};
